import {
  RX_JITTERS,
  TX_JITTERS,
  TX_PJ_FREQUENCY,
  TX_DCD,
  IBIS_TX_JITTERS,
  IBIS_RX_JITTERS,
  TX_PJ_AMPLITUDE,
} from "../../ADS/constant";
import _ from 'lodash';
import { JITTER_PDF_LIST } from "./constant";


function getJittersList(dirType, libType) {
  if (['tx', 'Driver'].includes(dirType)) {
    if (libType === 'IBIS_AMI') {
      return TX_JITTERS.filter(item => item !== TX_DCD)
    } else {
      return IBIS_TX_JITTERS
    }
  } else {
    if (libType === 'IBIS_AMI') {
      return RX_JITTERS
    } else {
      return IBIS_RX_JITTERS
    }
  }
}

function getJittersUnits(name) {
  switch (name) {
    // case TX_SJ_FREQUENCY:
    case TX_PJ_FREQUENCY:
      return ["Hz", "KHz", "MHz", "GHz"];
    case TX_PJ_AMPLITUDE:
      return ["s", "ms", "ns", "ps"];
    default: return [];
  }
}

function getJitterPDFByType(record) {
  const find = JITTER_PDF_LIST.find(item => item.key === record.type)
  if (find) {
    let newRecord = {
      name: record.name,
      type: record.type,
      unit: record.unit || "UI",
    }
    find.list.forEach(item => {
      const key = item.toLowerCase();
      newRecord[key] = key === "sigma" ? record.sigma : "";
    });
    return newRecord;
  }
  return record;
}

export {
  getJittersList,
  getJittersUnits,
  getJitterPDFByType
}